import { Box, Typography } from "@mui/material";

import EyeIcon from "../../../assets/SVG/eyeIcon";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import React, {
  useState,
  useMemo,
  useEffect,
  useRef,
  useCallback,
} from "react";
import { createRoot } from "react-dom/client";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css"; // Core CSS
import "ag-grid-community/styles/ag-theme-quartz.css"; // Them
import {
  getPatients,
  getPresenceList,
  putSubmitEntrance,
} from "../../../api/area";
import SearchInput from "../../project/searchInput";
import ExitIcon from "../../../assets/SVG/exitIcon";
import EditIconTable from "../../../assets/SVG/editIconTable";
import EditReceptionModal from "../sidebarArea/reception/editReceptionModal";
import TrashIcon from "../../../assets/SVG/trashIcon";
import DeleteAlertModal from "../../../pages/leaderGroup/deleteAlertModal";
import { removePatientFromArea } from "../../../api/group";
import MaleIcon from "../../../assets/SVG/maleIcon";
import FemaleIcon from "../../../assets/SVG/femaleIcon";

export default function TablePatient({ rowData, dataArea, setDataPatients }) {
  // const [rowData, setRowData] = useState([]);
  const [editModal, setEditModal] = useState(false);
  const [dataRowEdit, setDataRowEdit] = useState();
  const [deleteModal, setDeleteModal] = useState();
  // Column Definitions: Defines & controls grid columns.
  const handleDelete = () => {
    if (dataRowEdit) {
      removePatientFromArea(dataArea[0]?.areas[0]?.id, dataRowEdit.id)
        .then(() => {
          setDeleteModal(false);
          getPatients(dataArea[0]?.areas[0]?.id)
            .then((x) => {
              setDataPatients(x);
            })
            .catch(() => {});
        })
        .catch(() => {});
    }
  };
  const [colDefs] = useState([
    {
      headerName: "",
      valueGetter: "node.rowIndex + 1",
      width: 50,
    },
    {
      field: "patientInfo.name",
      headerName: "نام و نام خانوادگی",
      width: 225,
    },
    {
      field: "patientInfo.insurance",
      headerName: "وضعیت",
      width: 150,
      cellRenderer: (x) => {
        return (
          <>
            <Typography fontFamily="Shabnam">
              {x?.data?.patientInfo?.identifierType === "NATIONAL_CODE"
                ? "ایرانی"
                : "اتباع"}{" "}
            </Typography>
          </>
        );
      },
    },
    {
      field: "patientInfo.sex",
      headerName: "جنسیت",
      width: 150,
      cellRenderer: (x) => {
        return x.data.patientInfo.sex === "MALE" ? (
          <Box display="flex" alignItems="center">
            <MaleIcon size="0.5" />
            <Typography fontFamily="Shabnam">{" " + "مرد"}</Typography>
          </Box>
        ) : (
          <Box display="flex" alignItems="center">
            <FemaleIcon size="0.5" />
            <Typography fontFamily="Shabnam">{" " + "زن"}</Typography>
          </Box>
        );
      },
    },
    {
      field: "patientInfo.identifier",
      headerName: " کد ملی / اتباع",
      width: 200,
    },
    {
      field: "patientInfo.phone",
      headerName: "شماره تلفن",
      width: 150,
    },
    {
      field: "patientInfo.fatherName",
      headerName: "نام پدر",
      width: 150,
    },
    {
      field: "patientInfo.insurance",
      headerName: "بیمه",
      width: 150,
      cellRenderer: (x) => {
        return (
          <>
            <Typography fontFamily="Shabnam">
              {x?.data?.patientInfo?.insurance === "TAKMIL"
                ? "تکمیلی"
                : x?.data?.patientInfo?.insurance === "MILITARY"
                ? "نیروهای مسلح"
                : x?.data?.patientInfo?.insurance === "TAMIN"
                ? "تامین اجتماعی"
                : x?.data?.patientInfo?.insurance === "SALAMAT"
                ? "سلامت"
                : "ندارد "}{" "}
            </Typography>
          </>
        );
      },
    },
    {
      field: "patientInfo.insurance",
      headerName: "وضعیت سنی",
      width: 150,
      cellRenderer: (x) => {
        return (
          <>
            <Typography fontFamily="Shabnam">
              {x?.data?.patientInfo?.ageType === "ADULT" ? "بزرگسال" : "کودک"}{" "}
            </Typography>
          </>
        );
      },
    },
    {
      field: "patientInfo.birthDay",
      headerName: "تاریخ تولد",
      width: 150,
      cellRenderer: (x) => {
        return (
          <>
            <Typography fontFamily="Shabnam">
              {x.data.patientInfo.birthDate.split("-", 2)[0]}
            </Typography>
          </>
        );
      },
    },

    {
      field: "patientInfo.job",
      headerName: "شغل",
      width: 150,
    },
    {
      field: "patientInfo.patientNo",
      headerName: "شماره پرونده",
      width: 150,
    },
    {
      field: "expireAt",
      headerName: "عملیات",
      width: 220,
      cellRenderer: (x) => {
        return (
          <Box display="flex" gap="10px" alignItems="center">
            <Box
              width={"80px"}
              height="40px"
              textAlign="center"
              bgcolor="var(--emr-blue)"
              px="10px"
              borderRadius={"15px"}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              sx={{ cursor: "pointer" }}
              onClick={() => {
                setEditModal(true);
                setDataRowEdit(x.data.patientInfo);
              }}
            >
              <Typography color="white" fontFamily="Shabnam">
                {"ویرایش"}
              </Typography>
              <EditIconTable color="white" />
            </Box>
            <Box
              width={"60px"}
              height="40px"
              textAlign="center"
              bgcolor="var(--emr-red)"
              px="10px"
              borderRadius={"15px"}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              sx={{ cursor: "pointer" }}
              onClick={() => {
                setDeleteModal(true);
                setDataRowEdit(x.data.patientInfo);
              }}
            >
              <Typography color="white" fontFamily="Shabnam">
                {"حذف"}
              </Typography>
              <TrashIcon color="white" />
            </Box>
          </Box>
        );
      },
    },
    // {
    //   field: "area",
    //   headerName: "ورود و خروج",
    //   width: 320,
    //   cellRenderer: (x) => {
    //     return (
    //       <>
    //         {/* {x?.data?.areas?.map((z, i) => ( */}
    //         <>
    //           <Box
    //             bgcolor={"#2C685C"}
    //             color="white"
    //             borderRadius={"9px"}
    //             height="29px"
    //             display="flex"
    //             alignItems={"center"}
    //             gap="10px"
    //             p="5px"
    //             sx={{ cursor: "pointer" }}
    //             onClick={() =>
    //               putSubmitEntrance(x.data.user.id, areaId)
    //                 .then((x) => console.log(x))
    //                 .catch(() => {})
    //             }
    //           >
    //             <ExitIcon />
    //             <Typography color="white">{"ثبت ورود"}</Typography>
    //           </Box>
    //         </>
    //         {/* ))} */}
    //       </>
    //     );
    //   },
    // },
  ]);

  //   useEffect(() => {
  //     if (areaId) {
  //       getPresenceList(areaId)
  //         .then((x) => setRowData(x))
  //         .catch((z) => console.log(z));
  //     }
  //   }, [areaId]);
  const defaultColDef = useMemo(() => ({
    filter: true,
    editable: true,
  }));
  //   console.log(rowData);
  const [valueSearch, setValueSearch] = useState();
  const gridRef = useRef();
  const onFilterTextBoxChanged = useCallback(() => {
    gridRef.current.api.setGridOption(
      "quickFilterText",
      document.getElementById("filter-text-box").value
    );
  }, []);

  return (
    <>
      <DeleteAlertModal
        handleDelete={handleDelete}
        open={deleteModal}
        setOpen={setDeleteModal}
      />
      <EditReceptionModal
        data={dataRowEdit}
        open={editModal}
        setOpen={setEditModal}
        dataArea={dataArea}
        setDataPatients={setDataPatients}
      />
      <Box mt="20px" />
      <SearchInput
        type="text"
        id="filter-text-box"
        onInput={onFilterTextBoxChanged}
        value={valueSearch}
        onChange={(e) => setValueSearch(e.target.value)}
        mb="5px"
        mr="20px"
      />
      {/* <Typography className="icon-flight-land" /> */}
      <div
        className="ag-theme-quartz"
        style={{ height: "30vw", marginTop: 10 }}
      >
        <AgGridReact
          pagination={true}
          ref={gridRef}
          rowHeight={60}
          enableRtl={true}
          rowData={rowData}
          columnDefs={colDefs}
          defaultColDef={defaultColDef}
          // pagination={true}
          rowSelection="multiple"
          onSelectionChanged={(event) => console.log("Row Selected!")}
          onCellValueChanged={(event) =>
            console.log(`New Cell Value: ${event.value}`)
          }
        />
      </div>
    </>
  );
}
